/**
 * csvExport.js
 * ------------
 * Shared CSV-cell escaping for admin export buttons.
 *
 * Beyond the usual quote-escaping, this guards against "CSV/Formula
 * Injection": Excel (and some other spreadsheet apps) treat a cell starting
 * with =, +, -, or @ as a formula when a CSV is opened. Several of these
 * exports include fields anyone can set via the public registration forms
 * (name, school name, email, ...), so without this a registrant could plant
 * a formula (e.g. one that calls out to an external URL) that runs the
 * moment an admin opens the exported roster in Excel. Prefixing with a
 * straight quote defuses the formula while leaving the visible text
 * unchanged in the spreadsheet.
 */
export function csvCell(value) {
  let s = String(value ?? '');
  if (/^[=+\-@]/.test(s)) s = `'${s}`;
  return `"${s.replace(/"/g, '""')}"`;
}

// Joins a full table (header row + data rows) into a CSV string using
// csvCell for every field.
export function toCsv(rows) {
  return rows.map(row => row.map(csvCell).join(',')).join('\n');
}
